module.exports = __webpack_public_path__ + "img/1.c237bfc8.jpg";